import { Outlet, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useAdminAuth } from "./features/auth/AdminAuthProvider";

const SuperAdminPrivateRoute = () => {
  const { adminUser } = useAdminAuth();
  const isSuperAdmin = adminUser && adminUser.userType === "superadmin";
  const isDeveloper = adminUser && adminUser.userType === "developer";
  const isHOUser = adminUser && ["Credit Manager", "Accounts Manager", "Credit Officer", "Sanction Committee", "MIS"].includes(adminUser.userType);
  const navigate = useNavigate();

  useEffect(() => {
    if (!(isSuperAdmin || isDeveloper || isHOUser)) {
      navigate("/");
    }
  }, [isSuperAdmin, navigate, isDeveloper, isHOUser]);

  return (
    (isSuperAdmin || isDeveloper || isHOUser) && (
      <>
        <Outlet />
      </>
    )
  );
};

export default SuperAdminPrivateRoute;
